import { qs } from '@fluorescent/dom';

import { section } from '@/neon';
import mobileCarousel from '@/lib/mobile-carousel';

const sel = {
  slider: '[data-slider]',
};

section('featured-products', {
  onLoad() {
    const carousel = qs(sel.slider, this.container);

    if (!carousel) return;

    this.mobileCarousel = mobileCarousel(carousel, {
      adaptiveHeight: false,
      groupCells: 2,
    });
  },

  onUnload() {
    this.mobileCarousel.destroy();
  },
});
